import { Country } from 'api/countries/getCountriesList'
import useCurrentUser from 'hooks/CurrentUser'
import { useSelector } from 'react-redux'
import { countrySelector } from 'redux-store/country/country.selectors'

export const usePreferredCountry = (data: Country[]): Country | undefined => {
  const defaultAlpha2 = useSelector(countrySelector)
  const currentUser = useCurrentUser()

  if (currentUser?.area_code) {
    return data.find(
      (country: Country) => country.countryCode === currentUser.area_code
    )
  }

  return data.find((country: Country) =>
    defaultAlpha2 ? country.alpha2 === defaultAlpha2 : country.alpha2 === 'EN'
  )
}
